import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/AuthContext";

export default function ProtectedRoute({ children }) {
    const { authUser, authLoading } = useAuth()

    if (authLoading) {
        return (
            <div className="spinner-border spinner-border-sm-custom" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        )
    }

    if (!authUser) {
        return <Navigate to="/login" replace />;
    }

    return children;
}